import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import type { ConfigurationField as ConfigurationFieldType } from "../types";
import { FormField } from "./form-fields/form-field";

interface ConfigurationFieldProps {
  field: ConfigurationFieldType;
  disabled?: boolean;
  clientId?: string;
  moduleName?: string;
}

export function ConfigurationField({
  field,
  disabled,
  clientId,
  moduleName,
}: ConfigurationFieldProps) {
  const {
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation();
  const error = errors[field.key]?.message as string | undefined;
  const helpText = field["help-text"]?.startsWith("integrations.")
    ? t(field["help-text"])
    : field["help-text"];

  const fieldRendersOwnError =
    field.type === "reference" || field.type === "reference-list";

  return (
    <div className="space-y-2">
      <FormField
        field={field}
        disabled={disabled ?? false}
        clientId={clientId}
        moduleName={moduleName}
      />
      {helpText && <p className="text-sm text-muted-foreground">{helpText}</p>}
      {error && !fieldRendersOwnError && (
        <p className="text-sm text-destructive">{error}</p>
      )}
    </div>
  );
}
